<template>
  <div class="common-box">
    <div class="header"><slot name="header"></slot></div>
    <div class="body"><slot name="body"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'Box'
};
</script>

<style lang="scss" scoped>
.common-box {
  width: 100%;
  margin: 15px;
  box-shadow: $box-shadow;
  display: flex;
  flex-direction: column;
  & .header {
    background-color: $HIGHLIGHT_COLOR;
    color: #fff;
    font-size: 18px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 12px;
    min-height: 56px;
  }

  & .body {
    background-color: #fff;
    flex-grow: 1;
  }
}
</style>
